import { matchesHrmsFilters } from '../../components/hrms/hrmsFilterUtils';

export function filterEmployeesForLeave(employees, filters, search) {
  const query = search.trim().toLowerCase();
  return employees.filter(employee => matchesHrmsFilters(employee, filters) &&
    (!query || [employee.fullName, employee.nickname, employee.employeeCode].filter(Boolean).join(' ').toLowerCase().includes(query)));
}
